export class TopToolbarTextDataIT {
    static readonly htmlLabel = {
        welcome: 'Benvenuto',
        orgAdmin: '(Amministratore dell\'Organizzazione)',
        deptAdmin: '(Amministratore del Dipartimento)',
        licenseExpired: 'La tua licenza è scaduta. Contatta il supporto!',
        toolBoxPrepTraining: 'Formazione PREP',
        toolBoxQuickStartGuide: 'Guida Rapida',
        notificationHeading: 'Notifiche',
        notficationPart1Text: 'Hai ',
        notificationPart2Text: ' nuove notifiche.',
        notificationFineText: 'Tutto bene! Nessuna notifica al momento.',
        notificationMarkRead: 'Segna tutto come letto',
        resourceText: 'Risorse PREP',
        resourceTutorial: 'Formazione PREP',
        resourceOnboardDoc: 'Guida Rapida',
        resourceVideo: 'Video PREP',
        resourceVideoSubmenuItem1: 'Introduzione allo Strumento PREP',
        resourceVideoSubmenuItem2: 'Utilizzo dell\'Editor di Tag di Remediation',
        resourceVideoSubmenuItem3: 'Comprendere i Tipi di Tagging',
        resourceVideoSubmenuItem4: 'Informazioni Generali e Linee Guida',
        resourceVideoSubmenuItem5: 'Configurazione dell\'Account PREP',
        userProfileText: 'Profilo',
        userProfileLogoutText: 'Disconnettersi',
    };
    static readonly snackbarLabel = {

    };
    static readonly tooltipLabel = {
        toolBoxNotification: 'NOTIFICA',
        resourceMenu: 'Menu Risorse PREP',
        toolBoxPrepTraining: 'FORMAZIONE PREP',
        toolBoxHelp: 'AIUTO',
        toolBoxFullScreen: 'SCHERMO INTERO',
        toolBoxReleaseNotes: 'NOTE DI RILASCIO',
        toolBoxUserProfile: 'MENU PROFILO UTENTE',
    }
}